import { useState, useCallback, useRef } from 'react';

function useStoreValueInRef(value) {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}

/**
 * A hook used to hand-off state control to an external source while also maintaining
 * the internal state when external control is relinquished.
 */
function useStateEphemeral(initialState, externals) {
  var _externals$useExterna;
  const [internalState, internalDispatch] = useState(initialState);
  const {
    externalState
  } = externals;

  /*
  Wrap all the values in the dispatch functions in refs to prevent the
  useCallback from re-running during the lifetime of the hook.
  */
  const externalDispatchRef = useStoreValueInRef(externals.externalDispatch);
  const useExternalStateRef = useStoreValueInRef((_externals$useExterna = externals.useExternalState) !== null && _externals$useExterna !== void 0 ? _externals$useExterna : false);

  /*
  Create a component-lifetime-stable dispatch function that updates
  the internal or external dispatcher based on the value of `useExternalState`.
  */
  const dispatch = useCallback(newStateOrSetter => {
    if (useExternalStateRef.current && typeof externalDispatchRef.current === 'function') {
      externalDispatchRef.current(newStateOrSetter);
      return;
    }
    internalDispatch(newStateOrSetter);
  }, [externalDispatchRef, useExternalStateRef, internalDispatch]);

  /*
  Create a stable array to return the state and dispatcher. I'm not sure if this is
  needed to replicate the behavior of useState.
  */
  const {
    current: returnArray
  } = useRef([internalState, dispatch]);

  // Set the state based on the vaule of `useExternalState`
  if (useExternalStateRef.current && externalState) {
    returnArray[0] = externalState;
  } else {
    returnArray[0] = internalState;
  }
  return returnArray;
}

export { useStateEphemeral as u };
//# sourceMappingURL=useStateEphemeral-CrPQBxu_-CrPQBxu_.js.map
